export default __webpack_public_path__ + "static/new_york-d84ad26b360f4c82bc4c1ca3eab61293.svg";